import { createRouter, createWebHistory } from 'vue-router';
import routes from './routes';

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 跳转后返回顶部
router.afterEach((to, from, next) => {
  if (to.path !== from.path) {
    window.scrollTo(0, 0);
  }
  //
});

export default router;
